// Renders a typed name into a cursive ("Dancing Script") signature PNG data URL.
// Extracted from SignatureModal so it can be shared by non-component callers
// (e.g. the authorization PDF preview) without tripping react-refresh.

export const EXPORT_FONT_SIZE = 56
const EXPORT_W = 600
const EXPORT_H = 120

export async function nameToDataUrl(name: string): Promise<string> {
  await document.fonts.load(`${EXPORT_FONT_SIZE}px "Dancing Script"`)

  const ratio = Math.max(window.devicePixelRatio || 1, 3)
  const canvas = document.createElement('canvas')
  canvas.width = EXPORT_W * ratio
  canvas.height = EXPORT_H * ratio
  const ctx = canvas.getContext('2d')!
  ctx.scale(ratio, ratio)

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, EXPORT_W, EXPORT_H)

  // Signing guide line
  ctx.strokeStyle = 'rgba(180, 180, 180, 0.8)'
  ctx.lineWidth = 1
  ctx.beginPath()
  ctx.moveTo(16, EXPORT_H - 14)
  ctx.lineTo(EXPORT_W - 16, EXPORT_H - 14)
  ctx.stroke()

  ctx.fillStyle = '#000000'
  ctx.font = `${EXPORT_FONT_SIZE}px "Dancing Script", cursive`
  ctx.fillText(name, 16, EXPORT_H - 20, EXPORT_W - 32)

  return canvas.toDataURL('image/png')
}
